"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 bg-muted/30 animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.slice(0, 6).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="relative px-0 py-2 text-foreground font-medium text-sm transition-colors duration-[var(--duration-medium)] hover:!bg-transparent focus:!bg-transparent hover:text-primary focus:text-foreground-primary after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-smooth)] hover:after:w-full focus:after:w-full">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background/95 backdrop-blur-sm border-b border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 shadow-medium" : "h-24 shadow-soft"}`}>
      <div className="container mx-auto px-6 h-full flex items-center justify-between">
        <Link to="/" className="flex-shrink-0 flex items-center gap-3">
          
          <span className="font-display text-xl font-bold text-primary">
            MT4 Drone Service
          </span>
        </Link>

        <nav className="hidden lg:flex flex-1 justify-center">
          <MenuProvider menu_id="7">
            <HeaderMenuConsumer />
          </MenuProvider>
        </nav>

        <Button asChild className="ml-6 hover:!bg-primary-hover focus:!bg-primary-hover hover:scale-[1.02] active:scale-100 focus:scale-[1.02] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] shadow-soft hover:shadow-medium">
          <Link to="/ContactPage">Get Started</Link>
        </Button>
      </div>
    </header>;
}